import { get, isEmpty } from 'lodash'
import { required, requiredCheck, email } from 'utils/validation'

const validate = (values, props) => {
  let errors = {}

  const helpers = {
    terms: requiredCheck(get(values, 'helpers.terms'))
  }

  if (props.hasPolicy) {
    helpers.agreementPrivacyPolicy = requiredCheck(
      get(values, 'helpers.agreementPrivacyPolicy')
    )
  }

  errors = {
    helpers: !isEmpty(helpers) && helpers
  }

  errors.email = required(get(values, 'email')) || email(get(values, 'email'))
  errors.passwordAgain = required(get(values, 'passwordAgain'))

  if (get(values, 'password') && get(values, 'passwordAgain')) {
    if (get(values, 'password') !== get(values, 'passwordAgain')) {
      errors = {
        ...errors,
        passwordAgain: {
          text: "Passwords don't match",
          intlKey: 'errors.passwords_dont_match',
          values: {}
        }
      }
    }
  }

  return errors
}

export default validate
